<template>
  <ims-modal
    :title="$store.state.interact.modals.selectDriver.title"
    :canClose="true"
    :show="$store.state.interact.modals.selectDriver.show"
    :onClose="close"
  >
    <section class="drivers" v-if="race">
      <ims-item v-if="!drivers.length" class="pad ims-item-last">
        <h1>No Drivers Found</h1>
        <p>Drivers will be available when entry lists are posted.</p>
      </ims-item>
      <div class="item-wrapper" v-for="(driver, index) in sortedDriversMulti" :key="index">
        <ims-item v-if="!shouldHide(driver)" :disabled="!canSelect(driver)" @click="select(driver)">
          <template v-slot:left>
            <ims-avatar size="md" :src="driver.getAvatar()"></ims-avatar>
          </template>
          <h1>
            {{ driver.firstName }}
            {{ driver.lastName }}
          </h1>
          <template v-slot:right>
            <ims-badge color="green" size="sm" class="text-white top-left">${{driver.value}}</ims-badge>
          </template>
        </ims-item>
      </div>
      <ims-item class="divider" />
    </section>
    <section class="drivers empty-message" v-else>No Race Selected</section>
    <template v-slot:footer>
      <!-- Show meter if budget is in the store -->
      <div class="px-3" v-if="$store.state.interact.modals.selectDriver.budget !== null">
        <ims-meter
          v-if="race"
          class="py-3 mx-auto w-100"
          color="primary"
          :total="race.salaryCap"
          :current="budget"
        >
          <span class="text-sm">
            Salary Cap:
            <strong>${{ budget }}</strong> out of
            <strong>${{ race.salaryCap }}</strong>
          </span>
        </ims-meter>
      </div>
    </template>
  </ims-modal>
</template>

<script>
import AppConfig from '../../AppConfig';
export default {
  methods: {
    close() {
      // Close this modal
      this.$store.commit('modals/selectDriver', null);
    },
    select(driver) {
      // Fire off the Callback function stored in the modals.selectDriver state
      this.$store.state.interact.modals.selectDriver.callback(driver);
      setTimeout(() => {
        this.close();
      }, 120);
    },
    // Can we select this driver?
    // if we're using the budget, then calcuate the different.
    canSelect(driver) {
      if (this.useBudget) {
        let total = driver.value + this.budget;
        return driver.value + this.budget <= this.race.salaryCap;
      } else {
        return true;
      }
    },
    shouldHide(driver) {
      return (this.disableDrivers || []).indexOf(driver) > -1;
    }
  },
  computed: {
    race() {
      return this.$store.state.races.race;
    },
    drivers() {
      return this.race.drivers;
    },
    sortedDrivers() {
      return (this.drivers || []).sort((a, b) => {
        return a.value > b.value ? -1 : 1;
      });
    },
    sortedDriversMulti() {
      return (this.drivers || []).sort(function(a, b) {
        if (a.value > b.value) return -1;
        if (a.value < b.value) return 1;
        if (a.lastName > b.lastName) return 1;
        if (a.lastName < b.lastName) return -1;
      });
    },
    useBudget() {
      return this.$store.state.interact.modals.selectDriver.budget !== null;
    },
    disableDrivers() {
      return this.$store.state.interact.modals.selectDriver.disable;
    },
    budget() {
      return this.$store.state.interact.modals.selectDriver.budget;
    }
  }
};
</script>

<style></style>
